import DetalleSucursal from "./detalleSucursal";
import { Modal } from "../../../components/others/Modal/index";

type TProps = {
  toggleModal: boolean;
  urlTittle?: string;
  companyID?: string;
  companyId: any
  onClose: Function;
};

const DetalleSucursalModal = ({ toggleModal, urlTittle, companyId, onClose }: TProps) => {
  const styles = "text-2xl text-red-500 font-bold";
  return (
    <>
      <Modal
        show={toggleModal}
        modalTitle={`Información de la Sucursal`}
        titleStyle={styles}
        urlTittle={urlTittle}
        onClose={() => onClose?.()}
      >
        <DetalleSucursal
          key={companyId}
          companyId={companyId}
          onClose={() => onClose?.()}
        />
      </Modal>
    </>
  );
};

export default DetalleSucursalModal;
